export default __webpack_public_path__ + "static/media/GiftAid.d3753913.pdf";